import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import './Sidebar.css';

const Sidebar = () => {
  const { user } = useAuth();

  const menuItems = [
    {
      path: '/admin/dashboard',
      label: 'Dashboard',
      icon: '📊'
    },
    {
      path: '/admin/companies',
      label: 'Empresas',
      icon: '🏢',
      superAdminOnly: true  // Solo super_admin puede ver/gestión todas las empresas
    },
    {
      path: '/admin/chart-of-accounts',
      label: 'Plan de Cuentas',
      icon: '📋',
      permission: 'accounting.chart_of_accounts.view'
    },
    {
      path: '/admin/accounting-entries',
      label: 'Comprobantes',
      icon: '📝',
      permission: 'accounting.entries.view'
    },
    {
      path: '/admin/third-parties',
      label: 'Terceros',
      icon: '👤',
      permission: 'third_parties.view'
    },
    {
      path: '/admin/invoices',
      label: 'Facturas',
      icon: '🧾',
      permission: 'invoices.view'
    },
    {
      path: '/admin/retentions',
      label: 'Retenciones',
      icon: '📄',
      permission: 'retentions.view'
    },
    {
      path: '/admin/payroll',
      label: 'Nómina',
      icon: '💰',
      permission: 'payroll.view'
    },
    {
      path: '/admin/bank-reconciliation',
      label: 'Conciliación',
      icon: '🏦',
      permission: 'bank_reconciliation.view'
    },
    {
      path: '/admin/monthly-analysis',
      label: 'Análisis Mensual',
      icon: '📅',
      permission: 'dashboard.view'
    },
    {
      path: '/admin/reports',
      label: 'Reportes',
      icon: '📈',
      permission: 'reports.view'
    },
    {
      path: '/admin/tax-reports',
      label: 'Reportes Fiscales',
      icon: '📑',
      permission: 'reports.view'
    },
    {
      path: '/admin/users',
      label: 'Usuarios',
      icon: '👥',
      permission: 'users.view'
    }
  ];

  const canSeeMenuItem = (item) => {
    // Solo super_admin ve gestión de todas las empresas
    if (item.superAdminOnly) {
      return user?.role?.name === 'super_admin';
    }
    const permission = item.permission;
    if (!permission) return true;
    if (!user || !user.role) return false;
    if (user.role.name === 'super_admin') return true;

    const parts = permission.split('.');
    let perm = user.role.permissions;
    for (const p of parts) {
      perm = perm?.[p];
    }
    return perm === true;
  };

  const filteredMenuItems = menuItems.filter(item => canSeeMenuItem(item));

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h2>NUMBERS</h2>
        <p className="sidebar-subtitle">Sistema Contable</p>
      </div>

      <nav className="sidebar-nav">
        {filteredMenuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `sidebar-item ${isActive ? 'active' : ''}`
            }
          >
            <span className="sidebar-icon">{item.icon}</span>
            <span className="sidebar-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="user-info">
          <div className="user-avatar">
            {user?.firstName?.[0]}{user?.lastName?.[0]}
          </div>
          <div className="user-details">
            <p className="user-name">{user?.fullName}</p>
            <p className="user-role">{user?.role?.description}</p>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;

